import {
  REQUESTS_LIST_ERROR,
  SET_REQUESTS_LIST,
  SET_REQUESTS_PENDING,
} from "../requests/actionTypes"

const initialState = {
  isGetRequestsPending: false,
  requests: [],
  totalRecords: null,
  errorMessage: null,
};

export default (localState = initialState, action) => {
  switch (action.type) {
    case SET_REQUESTS_PENDING: {
      return {
        ...localState,
        isGetRequestsPending: true,
      };
    }
    case SET_REQUESTS_LIST: {
      const { requestsOdata } = action.payload;
      return {
        ...localState,
        isGetRequestsPending: false,
        errorMessage: null,
        requests: requestsOdata && requestsOdata.value,
        totalRecords: requestsOdata && requestsOdata['@odata.count'],
      };
    }
    case REQUESTS_LIST_ERROR: {
      const { errorMessage } = action.payload;
      return {
        ...localState,
        errorMessage: errorMessage,
        isGetRequestsPending: false,
        requests: [],
        totalRecords: 0,
      };
    }
    default: {
      return localState;
    }
  }
};
